export const EMPTY_RULE = {
  id: 0,
  attributeId: '',
  attributeCode: '',
  attributeName: '',
  attributeType: '',
  conditions: []
}
